// Get Notifications
export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_DONE = 'GET_NOTIFICATIONS_DONE';
export const GET_NOTIFICATIONS_FAILED = 'GET_NOTIFICATIONS_FAILED';

// Operations
export const SET_NOTIFICATIONS_FILTER = 'SET_NOTIFICATIONS_FILTER';
export const SET_NOTIFICATIONS_ALL_FILTERS = 'SET_NOTIFICATIONS_ALL_FILTERS';
export const CLEAR_NOTIFICATIONS_FILTERS = 'CLEAR_NOTIFICATIONS_FILTERS';